import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.yoga.radii.circle}px;
  padding: ${({ theme }) => theme.yoga.spacing.xxsmall}px
    ${({ theme }) => theme.yoga.spacing.xsmall}px;
  background: ${({ theme }) => theme.yoga.colors.white};
  border: ${({ theme }) => theme.yoga.borders.small}px solid;
  border-color: ${({ theme }) => theme.yoga.colors.tableBorder};
  width: 100%;

  svg {
    stroke: ${({ theme }) => theme.yoga.colors.checkboxBorderColor};
    height: ${({ theme }) => theme.yoga.spacing.small}px;
    width: ${({ theme }) => theme.yoga.spacing.small}px;
    margin-right: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  }

  input {
    outline: none;
    border: none;
    background: transparent;
    flex: 1;
    font-size: ${({ theme }) => theme.yoga.fontSizes.xsmall}px;
    line-height: ${({ theme }) => theme.yoga.lineHeights.xsmall}px;
    padding: ${({ theme }) => theme.yoga.spacing.zero};

    &::placeholder {
      color: ${({ theme }) => theme.yoga.colors.text.primary};
    }
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.yoga.colors.primary};

    svg {
      outline: 0;
      stroke: ${({ theme }) => theme.yoga.colors.primary};
    }
  }
`;
